import { render, staticRenderFns } from "./allstock.vue?vue&type=template&id=6bb910c4&"
import script from "./allstock.vue?vue&type=script&lang=js&"
export * from "./allstock.vue?vue&type=script&lang=js&"
import style0 from "./allstock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports